import sportsEventsTrainersList from '@/store/modules/sports-events-trainers/sports-events-trainers-list'
import sportsEventsTrainersDelete from '@/store/modules/sports-events-trainers/sports-events-trainers-delete'
import sportsEventsTrainersAdd from '@/store/modules/sports-events-trainers/sports-events-trainers-add'

export default {
  sportsEventsTrainersList,
  sportsEventsTrainersDelete,
  sportsEventsTrainersAdd,
}
